import { RefObject, useEffect, useRef } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TwoColTemplate from '@gym-templates/TwoColTemplate/TwoColTemplate';
import { AlertType } from '@gym-atoms/Alert/Alert';
import { Card } from 'primereact/card';
import GymAccessCategoryMappingTemplate from '../../templates/GymAccessCategoryMapping/GymAccessCategoryMappingTemplate';
import { useAppDispatch, useAppSelector } from '@gym-redux/store';
import Loader from '@gym-atoms/Loader/Loader';
import { fetchAccessCategories } from '../../../redux/slices/accessCategorySlice';

interface chainIdType {
  chainId: string;
}

const MainColumn = (props: { alertRef: RefObject<AlertType> }) => {
  const dispatch = useAppDispatch();
  const { accessCategoryId, gymId } = useParams<{
    accessCategoryId: string;
    gymId: string;
  }>();

  const { t } = useTranslation();

  useEffect(() => {
    if (gymId) {
      dispatch(fetchAccessCategories({ siteLocationId: +gymId }));
    }
  }, [dispatch, gymId]);

  const gymAccessCategory = useAppSelector((state) =>
    state.accessCategory.items
      .find((g) => g.siteLocationId === +gymId)
      ?.items.filter((item) => item.accessCategoryId === +accessCategoryId)
  );

  if (!gymAccessCategory) {
    return (
      <Card className="pt30 pl40 pr40 pb30">
        <div className="mr15 mb18">
          <Loader shape="rectangle" />
        </div>
        <div className="mr15 mb18">
          <Loader shape="rectangle" />
        </div>
        <div className="mr15 mb18">
          <Loader shape="rectangle" />
        </div>
      </Card>
    );
  }

  return (
    <Card className="pt30 pl40 pr40 pb30">
      <GymAccessCategoryMappingTemplate
        type="modify"
        heading={t('MODIFY_ACCESS_CATEGORY.PAGE_TITLE')}
        accessCategoryMapping={gymAccessCategory}
      />
    </Card>
  );
};

const ModifyGymAccessCategoryPage = () => {
  const { t } = useTranslation();
  const alertRef = useRef<AlertType>(null);
  const history = useHistory();
  const { chainId, gymId } = useParams<{ chainId: string; gymId: string }>();
  const location = useLocation<{ from?: string }>();
  const fromPage = location.state?.from;

  const getBackPath = () => {
    if (fromPage === 'chain') {
      return `/gymChains/${chainId}/gymChainAccessCategories`;
    }
    return `/gymChains/${chainId}/gyms/${gymId}/gymAccessCategories`;
  };

  return (
    <TwoColTemplate
      title={t('MODIFY_GYM_ACCESS_CATEGORY.PAGE_TITLE')}
      gymChainId={+chainId}
      col1={<MainColumn alertRef={alertRef} />}
      alertRef={alertRef}
      backButtonHandler={() => history.push(getBackPath())}
    />
  );
};

export default ModifyGymAccessCategoryPage;
